import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { ErrorBoundary } from 'react-error-boundary'
import App from './App'
import { AppErrorFallback } from './components/error-boundaries/ErrorFallback'
import { ErrorReportingService } from './lib/errorReporting'
import './index.css'

// Initialize error reporting
const errorReporting = new ErrorReportingService()
window.errorReporting = errorReporting

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!clerkPubKey) {
  console.error('Missing Clerk Publishable Key')
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={AppErrorFallback}
      onError={(error, info) => {
        errorReporting.captureException(error, { component: 'App', info })
      }}
    >
      <ClerkProvider 
        publishableKey={clerkPubKey}
        afterSignInUrl="/"
        afterSignUpUrl="/"
      >
        <App />
      </ClerkProvider>
    </ErrorBoundary>
  </React.StrictMode>
)